/**
 * Mapa central de prefetchers para as rotas mais navegadas.
 * Cada entrada é a MESMA função de import usada pelo lazyRetry no App.tsx.
 * Como Vite/Rollup deduplica imports dinâmicos, isso não duplica chunks —
 * apenas dispara o download antecipado quando o usuário passa o mouse.
 */
import { prefetch } from "./prefetch";

export const routePrefetchers: Record<string, () => Promise<unknown>> = {
  "/painel": () => import("@/pages/Dashboard"),
  "/perfil": () => import("@/pages/UserProfile"),
  "/torneios": () => import("@/pages/Tournaments"),
  "/torneios-publicos": () => import("@/pages/PublicTournaments"),
  "/torneios/novo": () => import("@/pages/TournamentCreateMode"),
  "/times": () => import("@/pages/Teams"),
  "/equipes": () => import("@/pages/Teams"),
  "/minhas-inscricoes": () => import("@/pages/MyRegistrations"),
  "/favoritos": () => import("@/pages/Favorites"),
  "/painel-organizador": () => import("@/pages/OrganizerDashboard"),
  "/minhas-arenas": () => import("@/pages/MinhasArenas"),
  "/atleta": () => import("@/pages/athlete/AthleteHome"),
  "/atleta/reservas": () => import("@/pages/athlete/AthleteReservas"),
  "/atleta/aulas": () => import("@/pages/athlete/AthleteAulas"),
  "/atleta/jogos": () => import("@/pages/athlete/AthleteJogos"),
  "/atleta/inscricoes": () => import("@/pages/MyRegistrations"),
  "/atleta/notificacoes": () => import("@/pages/athlete/AthleteNotificacoes"),
  "/atleta/ranking": () => import("@/pages/GlobalRanking"),
  "/atleta/historico": () => import("@/pages/AthleteProfile"),
  "/atleta/perfil": () => import("@/pages/AthleteProfile"),
  "/atleta/times": () => import("@/pages/Teams"),
};

/**
 * Dispara prefetch para uma rota se houver um importer registrado.
 * Match por prefixo: /atleta/times -> tenta /atleta/times depois /atleta.
 */
export function prefetchRoute(pathname: string) {
  // Tenta match exato primeiro
  if (routePrefetchers[pathname]) {
    prefetch(routePrefetchers[pathname]);
    return;
  }
  // Fallback para prefixo conhecido
  const segments = pathname.split("/").filter(Boolean);
  while (segments.length > 0) {
    const candidate = "/" + segments.join("/");
    if (routePrefetchers[candidate]) {
      prefetch(routePrefetchers[candidate]);
      return;
    }
    segments.pop();
  }
}
